import { render, staticRenderFns } from "./SoldByCard.vue?vue&type=template&id=cf5bdc8e"
import script from "./SoldByCard.vue?vue&type=script&lang=ts"
export * from "./SoldByCard.vue?vue&type=script&lang=ts"
import style0 from "./SoldByCard.vue?vue&type=style&index=0&id=cf5bdc8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports